<script>
import {mapMutations} from "vuex";
import {setLang} from "../../../i18n";

export default {
    name: "SurveyLanguageSelector",
    data() {
        return {
            languages: [
                { title: 'English', value: 'en' },
                { title: 'Français', value: 'fr' },
            ]
        }
    },
    mounted() {
        setLang(this.selectedLanguage);
    },
    computed: {
        selectedLanguage: {
            get() {
                return this.$store.state.surveys.currentLanguage
            },
            set(value) {
                this.setCurrentLanguage(value)
                setLang(value);
            }
        }
    },
    methods: {
        ...mapMutations('surveys', [
            'setCurrentLanguage'
        ])
    }
}
</script>

<template>
    <v-select
        v-model="selectedLanguage"
        :items="languages"
        label="Langue du formulaire"
        item-text="title"
        item-value="value"
        class="selector px-2"
    ></v-select>
</template>

<style scoped>
    .selector {
        max-width: 200px;
    }
</style>

